"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withModuleProps = exports.useModuleProps = exports.default = void 0;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const ModuleProps = /*#__PURE__*/(0, _react.createContext)({});
const useModuleProps = function () {
  const props = (0, _react.useContext)(ModuleProps);
  return props;
};
exports.useModuleProps = useModuleProps;
const withModuleProps = function (Component, slice) {
  return function (props) {
    const moduleProps = useModuleProps();
    const providerData = slice && typeof slice === "string" && moduleProps !== null && moduleProps !== void 0 && moduleProps[slice] ? {
      ...(moduleProps === null || moduleProps === void 0 ? void 0 : moduleProps[slice]),
      ...props
    } : slice && typeof slice === "function" ? {
      ...slice(moduleProps),
      ...props
    } : props;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(ModuleProps.Provider, {
      value: providerData,
      "data-testid": "withModuleProps",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, {
        ...providerData
      })
    });
  };
};
exports.withModuleProps = withModuleProps;
var _default = exports.default = ModuleProps;